import { Box } from '@chakra-ui/react';
import React from 'react';
import { AnswerBoxProps } from '../../interfaces/components';

function AnswerBox({ activeLocale, text, onClick }: AnswerBoxProps) {
  return (
    <Box
      textAlign="center"
      display="flex"
      justifyContent="center"
      alignItems="center"
      w={['100%', '100%', '100%', 'auto']}
      p={['0px 10px']}
      _notLast={{ marginRight: ['0px', '0px', '0px', '5px'] }}
      marginBottom={['5px']}
      h={['40px']}
      bg="white"
      color="black"
      fontFamily={activeLocale.includes('ar') ? 'GETwoLight' : 'RalewayMedium'}
      fontWeight="900"
      lineHeight={['15px', '15px', '15px', '15px']}
      fontSize={['12px', '12px', '13px', '14px']}
      textTransform="uppercase"
      border="1px solid black"
      _hover={{ bg: 'lightgrey' }}
      cursor="pointer"
      transition="0.2s ease-in all"
      onClick={onClick}
    >
      {text}
    </Box>
  );
}

export default AnswerBox;
